<template>
  <div class="form-field" :class="props.class">
    <label class="form-label" :for="uniqueId" v-html="props.label"></label>
    <div class="form-file">
      <input type="file" :id="uniqueId" multiple v-on:change="handleSelect" v-bind="$attrs">
      <div class="form-file__wrap">
        <span class="form-filename" :data-msg="props.placeholder">{{props.placeholder}}</span>
      </div>
      <ul class="form-file__list">
        <li v-for="(item,i) in model" :key="i">
          <button type="button" class="btn-delete btn-delete--sm" @click.stop.prevent="removeFile(i)">
            <span class="btn-delete__icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.75 8.75C10.3023 8.75 10.75 9.19772 10.75 9.75V15.75C10.75 16.3023 10.3023 16.75 9.75 16.75C9.19772 16.75 8.75 16.3023 8.75 15.75V9.75C8.75 9.19772 9.19772 8.75 9.75 8.75Z" fill="#F5F5F5"/>
                <path d="M14.25 8.75C14.8023 8.75 15.25 9.19772 15.25 9.75V15.75C15.25 16.3023 14.8023 16.75 14.25 16.75C13.6977 16.75 13.25 16.3023 13.25 15.75V9.75C13.25 9.19772 13.6977 8.75 14.25 8.75Z" fill="#F5F5F5"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M14.25 1.25C14.913 1.25 15.5487 1.51358 16.0176 1.98242C16.4864 2.45126 16.75 3.08696 16.75 3.75V4.25H20.25C20.8023 4.25 21.25 4.69772 21.25 5.25C21.25 5.80228 20.8023 6.25 20.25 6.25H19.75V19.5C19.75 19.9641 19.5655 20.4091 19.2373 20.7373C18.9091 21.0655 18.4641 21.25 18 21.25H6C5.53587 21.25 5.09089 21.0655 4.7627 20.7373C4.43451 20.4091 4.25 19.9641 4.25 19.5V6.25H3.75C3.19772 6.25 2.75 5.80228 2.75 5.25C2.75 4.69772 3.19772 4.25 3.75 4.25H7.25V3.75C7.25 3.08696 7.51358 2.45126 7.98242 1.98242C8.45126 1.51358 9.08696 1.25 9.75 1.25H14.25ZM6.25 19.25H17.75V6.25H6.25V19.25ZM9.75 3.25C9.61739 3.25 9.49025 3.30272 9.39648 3.39648C9.30272 3.49025 9.25 3.61739 9.25 3.75V4.25H14.75V3.75C14.75 3.61739 14.6973 3.49025 14.6035 3.39648C14.5331 3.32608 14.4439 3.27894 14.3477 3.25977L14.25 3.25H9.75Z" fill="#F5F5F5"/></svg>
            </span>
          </button>
          {{ item.name }}
        </li>
      </ul>
    </div>
  </div>
</template>
<script setup>
import {ref} from 'vue';
import useUniqueId from '../../../directives/uniqueId';

defineOptions({
  inheritAttrs: false
});

const {uniqueId} = useUniqueId();

const props = defineProps({
  class: {
    type: String,
  },
  label: {
    type: String,
    default: 'Informe o label'
  },
  placeholder: {
    type: String,
    default: 'Informe o placeholder'
  },
  deleteLabel: {
    type: String,
    default: 'Excluir'
  }
});

const model = defineModel({ type: Array, default: () => [] });
const files = ref([]);

function removeFile(i) {
  model.value.splice(i,1);

}

function handleSelect(ev) {
  if(ev.target.files.length) {
    for (let i = 0; i < ev.target.files.length; i++) {
      model.value.push(ev.target.files[i]);
    }
    ev.target.value = null;
  }
}
</script>
